module.exports = __webpack_public_path__ + "img/banner2.b255f7c8.png";